import React, { useState } from "react";

import axios from "axios";
import Swal from "sweetalert2";
import BASE_URL from "../config";
const NewsletterForm = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
    });

    const [validationErrors, setValidationErrors] = useState({});

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value,
        });

        // Clear validation error for the specific field
        setValidationErrors((prevErrors) => {
            const { [id]: removedError, ...remainingErrors } = prevErrors;
            return remainingErrors;
        });
    };

    const validateForm = () => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression for email validation
        const phoneRegex = /^[0-9()+\s-]+$/; // Updated regex for phone number validation

        if (!formData.name.trim()) {
            errors.name = "Name is required.";
        }

        if (!formData.email.trim()) {
            errors.email = "Email is required.";
        } else if (!emailRegex.test(formData.email)) {
            errors.email = "Invalid email format.";
        }

        if (!formData.phone.trim()) {
            errors.phone = "Phone number is required.";
        } else if (!phoneRegex.test(formData.phone)) {
            errors.phone = "Phone number can only contain numbers.";
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (validateForm()) {
    const htmlTable = `
      <table border="1" cellpadding="10" cellspacing="0" style="border-collapse: collapse; font-family: Arial, sans-serif; width: 100%;">
        <tr style="background-color: #f2f2f2;">
          <th align="left">Name</th>
          <td>${formData.name}</td>
        </tr>
        <tr>
          <th align="left">Email</th>
          <td>${formData.email}</td>
        </tr>
        <tr style="background-color: #f2f2f2;">
          <th align="left">Phone Number</th>
          <td>${formData.phone}</td>
        </tr>
      </table>
    `;

    try {
      setLoading(true);

      await axios.post(`${BASE_URL}api/email/newsletter`, {
        bodyText: htmlTable,
      });

      Swal.fire({
        icon: "success",
        title: "Subscription Successful",
        text: "Thank you for subscribing!",
      });

      setFormData({
        name: "",
        email: "",
        phone: "",
      });
      setValidationErrors({});
    } catch (error) {
      console.error("Error sending subscription:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error submitting your subscription. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  }
};


    return (
        <form className="newsletter-form" onSubmit={handleSubmit}>
            <div>
                <input
                    type="text"
                    id="name"
                    placeholder="Name"
                    className="newsletter-input"
                    value={formData.name}
                    onChange={handleInputChange}
                    onFocus={() => setValidationErrors((prev) => ({ ...prev, name: undefined }))}
                />
                {validationErrors.name && <small className="text-danger" style={{ display: "block", textAlign: "left", marginTop: "5px" }}>{validationErrors.name}</small>}
            </div>
            <div>
                <input
                    type="email"
                    id="email"
                    placeholder="Email"
                    className="newsletter-input"
                    value={formData.email}
                    onChange={handleInputChange}
                    onFocus={() => setValidationErrors((prev) => ({ ...prev, email: undefined }))}
                />
                {validationErrors.email && <small className="text-danger" style={{ display: "block", textAlign: "left", marginTop: "5px" }}>{validationErrors.email}</small>}
            </div>
            <div>
                <input
                    type="text"
                    id="phone"
                    placeholder="Phone Number"
                    className="newsletter-input"
                    value={formData.phone}
                    onChange={handleInputChange}
                    onFocus={() => setValidationErrors((prev) => ({ ...prev, phone: undefined }))}
                />
                {validationErrors.phone && <small className="text-danger" style={{ display: "block", textAlign: "left", marginTop: "5px" }}>{validationErrors.phone}</small>}
            </div>
            <button
  type="submit"
  className="newsletter-button"
  disabled={loading}
  style={{
    cursor: loading ? "not-allowed" : "pointer",
    opacity: loading ? 0.7 : 1,
  }}
>
  {loading ? (
    <>
      <span
        className="spinner"
        style={{
          display: "inline-block",
          width: "16px",
          height: "16px",
          border: "2px solid #fff",
          borderTop: "2px solid transparent",
          borderRadius: "50%",
          marginRight: "8px",
          animation: "spin 1s linear infinite",
          verticalAlign: "middle",
        }}
      ></span>
      Submitting...
    </>
  ) : (
    "Submit"
  )}
</button>

        </form>
    );
};

export default NewsletterForm;
